export default __webpack_public_path__ + "static/media/Star.a23e9f4d.svg";